export default __webpack_public_path__ + "static/media/header_book.b25d7e02.png";